import { Card, Col, Row, Spin, Typography } from 'antd';
import PropTypes from 'prop-types';

import './OverdueDueSoonCounterStyles.css';

const { Text } = Typography;

const PMCountWidget = ({
  isLoadingPMCounts,
  pmCounts,
  handlePMsCountClick,
}) => {
  return (
    <Card style={{ height: '50%' }}>
      <div className="card-title">
        <Text strong>PMs</Text>
      </div>
      <Row style={{ marginTop: 8 }} gutter={[16, 16]}>
        <Col span={24}>
          <div
            className="safety-inspection-col"
            style={{
              height: 'auto',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
            }}
          >
            {isLoadingPMCounts ? (
              <Spin />
            ) : (
              <>
                <div
                  className="clickable-section"
                  onClick={() => handlePMsCountClick('overdue')}
                >
                  <div
                    className="overdue item"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      textAlign: 'center',
                    }}
                  >
                    <span className="count">{pmCounts.overdue_count}</span>
                    <span className="label">Overdue</span>
                  </div>
                </div>
                <div
                  className="clickable-section"
                  onClick={() => handlePMsCountClick('dueSoon')}
                >
                  <div
                    className="due-soon item"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      textAlign: 'center',
                    }}
                  >
                    <span className="count">{pmCounts.due_soon_count}</span>
                    <span className="label">Due Soon</span>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
    </Card>
  );
};

PMCountWidget.propTypes = {
  isLoadingPMCounts: PropTypes.bool,
  pmCounts: PropTypes.shape({
    overdue_count: PropTypes.any,
    due_soon_count: PropTypes.any,
  }),
  handlePMsCountClick: PropTypes.func,
};

PMCountWidget.defaultProps = {
  isLoadingPMCounts: false,
  pmCounts: {
    overdue_count: 0,
    due_soon_count: 0,
  },
  handlePMsCountClick: () => {},
};

export default PMCountWidget;
